import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { SideNavEvents } from '../types';
import { ResizableMixin } from '../../../mixins';

export class GzPushBodyLayoutWebComponent extends ResizableMixin(LitElement) {
  @property({ type: Boolean, attribute: true, reflect: true })
  isOpen = true;

  @property({ type: Boolean, attribute: true, reflect: true })
  disabled = false;

  @query('#toggleNav')
  private button!: HTMLInputElement;

  @query('#pushBodySidenav')
  private pushBodySidenav!: HTMLElement;

  static get styles() {
    return styles;
  }

  render() {
    return html`
        <div class="push-body-layout">
            <div id="pushBodySidenav" class="push-body-sidenav ${
              this.resizable ? 'resize-content' : ''
            }" part="sideNav" @click="${this.handleBodyClicked}">
                <div class="header" part="header">
                    <div class="title"><slot name="push-body-sidenav-title"></slot></div>
                    <gz-icon-button
                    id="toggleNav"
                    size="24"
                    fontSize="20"
                    buttonType="square"
                    icon="${!this.isOpen ? 'ds-icon-arrow_right_expand' : 'ds-icon-arrow_left_collapse'}"
                    buttonFill="quiet"
                    buttonColor="secondary"
                    @click="${this.toggleSideNav}"
                    class="push-body-toggle"
                    >
                    </div>
                    ${this.renderHandler()}
                <div class="content" part="push-body-layout-sidenav-content">
                    <slot name="push-body-sidenav"></slot>
                </div>
            </div>
            <div class="push-body-content">
              <div class="header" part="content-header">
                <slot name="push-body-content-header"></slot>
              </div>

              <div class="toolbar" part="content-toolbar">
                <slot name="push-body-content-toolbar"></slot>
              </div>
              <div class="content" part="content">
                <slot name="push-body-content"></slot>
              </div>
            </div>
        </div>
    `;
  }

  private renderHandler() {
    if (this.resizable && this.isOpen) {
      return this.renderResizeHandler();
    }
  }

  toggleSideNav() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.dispatchEvent(new CustomEvent(SideNavEvents.OPEN));
    } else {
      this.isOpen = false;
      if (this.pushBodySidenav.hasAttribute('style')) {
        this.pushBodySidenav.removeAttribute('style');
      }
      this.dispatchEvent(new CustomEvent(SideNavEvents.CLOSE));
    }
  }

  toggleOpenAndDisabledSideNav() {
    if (!this.disabled) {
      this.isOpen = false;
      this.disabled = true;
      this.button.disabled = true;
    } else {
      this.isOpen = true;
      this.disabled = false;
      this.button.disabled = false;
    }
  }

  handleBodyClicked() {
    this.dispatchEvent(new CustomEvent(SideNavEvents.CLICKED));
  }
}
